import * as ActionTypes from '../Live';

export function clearLive() {
    return {type: ActionTypes.CLEAR_LIVE, section: 'live'};
}



// WEBPACK FOOTER //
// ./js/actions/creators/Live.js